<template>
  <div>
    <ts-loading-banner :loading="loading">
      <form class="form-horizontal">
        <div class="row form-group">
          <label class="col-form-label col-md-4">{{
            $t('studentGallery.eventDate')
          }}</label>
          <div class="col-md-6">
            <ts-date-picker-input v-model="model.event_date">
            </ts-date-picker-input>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('studentGallery.eventName')
          }}</label>
          <div class="col-md-6">
            <input type="text" class="form-control" v-model="model.event_name"
              :class="{ 'is-invalid': errors.has('event_name') }" />
            <div class="invalid-feedback" v-if="errors.has('event_name')">
              {{ errors.first('event_name') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-form-label col-md-4"></label>
          <div class="col-md-6">
            <a-radio-group v-model="acStatusId" @change="loadClass" size="small">
              <a-radio-button :value="1">
                {{ $t('studentGallery.current') }}
              </a-radio-button>
              <a-radio-button :value="2">
                {{ $t('studentGallery.history') }}
              </a-radio-button>
            </a-radio-group>
            <div class="validate" v-if="errors.has('class_id')">
              {{ errors.first('class_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4">{{
            $t('studentGallery.className')
          }}</label>
          <div class="col-md-6">
            <a-select v-model.number="model.class_id" style="width: 100%" :options="class_list" :show-search="true"
              option-filter-prop="children" allowClear placeholder="All" :filter-option="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                " @change="onClassChange"></a-select>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4">{{
            $t('studentGallery.studentName')
          }}</label>
          <div class="col-md-6">
            <a-select v-model.number="model.student_id" style="width: 100%" :options="student_list" :show-search="true"
              option-filter-prop="children" allowClear placeholder="All" :filter-option="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                "></a-select>
          </div>
        </div>
        <upload-photo v-model="model" ref="upload_photo" />
        <div class="validate" v-if="errors.has('attach_file_list')">
          {{ errors.first('attach_file_list') }}
        </div>
        <br />
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button class="mr-2" @click="clearInput">{{
              $t('cancel')
            }}</ts-button>
            <ts-button color="primary" :disabled="model.attach_file_list.length == 0" :waiting="waiting"
              @click.prevent="save">{{ $t('save') }}</ts-button>
          </div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import UploadPhoto from './upload-photo.vue'
import moment from 'moment'
export default {
  name: 'form',
  components: {
    UploadPhoto
  },
  data() {
    return {
      loading: false,
      waiting: false,
      class_list: [],
      student_list: [],
      errors: new Errors(),
      model: {
        upload_id: 0,
        student_id: undefined,
        class_id: null,
        event_date: moment().format('DD-MM-YYYY'),
        event_name: null,
        attach_file_list: []
      }
    }
  },
  created() {
    this.loadClass()
  },
  computed: {
    acStatusId: {
      get() {
        return this.$store.state.staffStudentGallery.ac_status_id
      },
      set(newValue) {
        this.$store.commit('staffStudentGallery/SET_AC_STATUS', newValue)
      }
    }
  },
  methods: {
    loadClass() {
      if (!this.isEdit) {
        this.class_list = []
        this.student_list = []
        this.model.class_id = null
        this.model.student_id = undefined
      }
      this.loading = true
      this.$store
        .dispatch('staffStudentGallery/getClassOperation')
        .then(response => {
          this.class_list = response.data.map(el => ({
            value: el.class_id,
            label: el.class_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClassChange() {
      if (!this.isEdit) {
        this.student_list = []
        this.model.student_id = undefined
      }
      this.loading = true
      this.$store
        .dispatch(
          'staffStudentGallery/getStudentEnrollmentByClass',
          this.model.class_id
        )
        .then(response => {
          this.student_list = response.data
            .filter(e => e.student_profile != null)
            .map(el => ({
              value: el.student_profile.student_id,
              label:
                el.student_profile.card_number +
                '|' +
                el.student_profile.full_name_en
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('staffStudentGallery/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$emit('fetchData')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearInput() {
      this.$emit('close')
      this.errors = new Errors()
      this.model.upload_id = 0
      this.model.student_id = undefined
      this.model.class_id = null
      this.model.event_name = null
      this.model.attach_file_list = []
      this.$refs.upload_photo.fileRecords = []
    }
  }
}
</script>
